import { MapboxOverlay } from '@deck.gl/mapbox';
import { attempt } from 'es-toolkit/util';
import { Map as MapboxMap, MapMouseEvent } from 'shared/map-exports';

const overlaysByMap = new WeakMap<MapboxMap, MapboxOverlay>();

/** Returns a cleanup that unregisters the overlay. */
export const registerDeckOverlay = (
  map: MapboxMap,
  overlay: MapboxOverlay,
): (() => void) => {
  overlaysByMap.set(map, overlay);
  return () => {
    if (overlaysByMap.get(map) === overlay) {
      overlaysByMap.delete(map);
    }
  };
};

/**
 * Whether a click landed on a pickable deck.gl object.
 */
export const isDeckObjectAtMapClick = (event: MapMouseEvent): boolean => {
  const overlay = overlaysByMap.get(event.target);
  if (!overlay) {
    return false;
  }
  // pickObject asserts if deck hasn't been created yet.
  const [error, info] = attempt(() =>
    overlay.pickObject({ x: event.point.x, y: event.point.y }),
  );
  return !error && Boolean(info?.object);
};
